export const SET_AUTH_ERROR = 'EXAMS_ERRORS_SET_AUTH_ERROR';
export const SET_ERROR = 'EXAMS_ERRORS_SET_ERROR';
export const DISMISS_AUTH_ERROR = 'EXAMS_ERRORS_DISMISS_AUTH_ERROR';
export const DISMISS_ERROR = 'EXAMS_ERRORS_DISMISS_ERROR';
export const DISPOSE = 'EXAMS_ERRORS_DISPOSE';
